"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var utils_1 = require("../../modules/transaction/utils");

var TransactionLink = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(TransactionLink, _React$PureComponent);

  function TransactionLink() {
    _classCallCheck(this, TransactionLink);

    return _possibleConstructorReturn(this, _getPrototypeOf(TransactionLink).apply(this, arguments));
  }

  _createClass(TransactionLink, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          address = _this$props.address,
          txHash = _this$props.txHash;

      if (!address && !txHash) {
        console.warn('Tried to render an TransactionLink without either an address or tx hash. Please supply one of those');
        return null;
      }

      var _this$props2 = this.props,
          chainId = _this$props2.chainId,
          className = _this$props2.className,
          target = _this$props2.target,
          text = _this$props2.text,
          children = _this$props2.children;
      var href = utils_1.getTransactionHref({
        address: address,
        txHash: txHash
      }, chainId);
      return React.createElement("a", {
        className: className,
        href: href,
        target: target
      }, children || text || href);
    }
  }]);

  return TransactionLink;
}(React.PureComponent);

exports.default = TransactionLink;
TransactionLink.defaultProps = {
  className: 'etherscan-link',
  target: '_blank',
  text: ''
};